import Header from "components/Headers/Header";
import moment from "moment";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
import { CSVLink } from "react-csv";
import { useRef } from "react";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const Orders = () => {
  const csvLink = useRef(null);
  const [loader] = useState({ data: false });
  const headers = [
    { label: "Name", key: "name" },
    { label: "Company", key: "companyName" },
    { label: "APT #", key: "appartment" },
    { label: "State", key: "state" },
    { label: "City", key: "city" },
    { label: "Address", key: "address" },
    { label: "Country", key: "country" },
    { label: "Zipcode", key: "postalCode" },
    { label: "Type", key: "type" },
    { label: "Date of Purchase", key: "time_stamps" },
    { label: "Amount", key: "amount" },
    { label: "quantity", key: "quantity" },
  ];

  const infoPoints = [
    "When a fan places an order through the Shop module, it appears here for the admin to review. However, the Shop module is currently removed from the FHP homepage.",
  ];
  const subPoints = [];
  const infoTitle = "Orders Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  return (
    <>
      <Header />
      <Container fluid className="mt-4">
        <div id="divToPrint">
          <Card className="p-2 mt-4">
            <Row className="justify-content-end align-items-center">
              <Col xs={12} md={8} lg={6} className="text-md-end mt-2 mt-md-0">
                <div className="d-flex flex-column flex-sm-row justify-content-md-end">
                  <CSVLink
                    ref={csvLink}
                    headers={headers}
                    filename={`Orders ${moment(new Date()).format("DD-MM-YYYY")}.csv`}
                    data={[]}
                    className="w-100 w-sm-50 w-lg-auto mb-2 mb-sm-0 mr-sm-2 mt-4 btn btn-primary disabled"
                    onClick={(e) => e.preventDefault()}
                  >
                    Export Orders
                  </CSVLink>

                  <Button
                    color="primary"
                    className="btn btn-primary w-100 w-sm-50 w-lg-auto mt-4 ml-0"
                    onClick={() => {}}
                    disabled
                  >
                    Print
                  </Button>

                  <h2
                    className="mb-0 mt-4 text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => setInfoModalOpen(true)}
                  >
                    <i className="fa fa-question-circle" aria-hidden="true"></i>
                  </h2>
                </div>
              </Col>
            </Row>

            {loader.data ? (
              <div className="text-center py-4">
                <Spinner color="primary" />
              </div>
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "250px" }}
              >
                <h3 className="mb-0 text-center">Currently not available</h3>
              </div>
            )}
          </Card>
        </div>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
};

export default Orders;
